/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as printJS from 'print-js';
import { AppService } from './app.service';
import { environment } from './../environments/environment';

@Injectable({ providedIn: 'root' })
export class DutyProceedingsInitiationService {
  constructor(private httpClient: HttpClient, private app: AppService) {}

  createDPIRequest(dto: any) {
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    return this.httpClient.post(
      this.app.getUrl() + environment.createDutyProceedingsInitiationUrl,
      dto,
      { responseType: 'blob' as 'json', headers }
     ).subscribe((result: Blob) => {
        const fileURL = URL.createObjectURL(result);
        const anchor = document.createElement('a');
        anchor.download = 'Одлука o покретању поступка.pdf';
        anchor.href = fileURL;
        anchor.click();
      });
     
  }

  printPreview(dto: any) {
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    return this.httpClient.post(
      this.app.getUrl() + environment.createDutyProceedingsInitiationUrl,
      dto,
      { responseType: 'blob', headers }
    ).subscribe(data => {
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          printJS(fileURL);
        });
  }


}
